import React, { Component } from 'react';
import SingleBar from './SingleBar';
import { withAnalyticsAppContext } from '../../context/analytics-app-context';
import { isEmpty } from '../../utils/object-utils';
import './analytics-time-bar-chart.scss';

class AnalyticsTimeBarChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showBarMessage: false,
            barMessage: ''
        };

        this.barChartBodyRoot = React.createRef();
        this.setShowBarMessage = this.setShowBarMessage.bind(this);
        this.displayChartBars = this.displayChartBars.bind(this);
        this.displayBarBannerMessage = this.displayBarBannerMessage.bind(this);
    }

    displayChartBars() {
        const { appContext } = this.props;
        const { loading } = appContext;
        const { analyticsForPagesData } = appContext.analyticsData || {};
        if (loading || isEmpty(analyticsForPagesData)) {
            return null;
        }

        const siteDataKeys = [];
        return analyticsForPagesData.map((analyticsTime, index) => {
            const siteDataKey = `${analyticsTime.formattedCreatedDate}_${analyticsTime.formattedCreatedTime}_${analyticsTime.accessedURL}`;
            if (!siteDataKeys.includes(siteDataKey)) {
                siteDataKeys.push(siteDataKey);
                const max = 300;
                const y = max - (max * analyticsTime.visitedPercentage) / 100;
                return (
                    <SingleBar
                        key={index}
                        onMouseEnterSingleBar={this.setShowBarMessage}
                        onMouseExitSingleBar={this.setShowBarMessage}
                        item={analyticsTime}
                        width="60px"
                        height="300px"
                        color="#1e88e5"
                        percentage={`${analyticsTime.visitedPercentage}%`}
                        data={`M 0 ${max} L 0  ${y} L 60 ${y} l 60 ${max} Z`}
                    />
                );
            }
        });
    }

    displayBarBannerMessage() {
        const { barMessage, showBarMessage } = this.state;
        const { appContext } = this.props;
        const { loading } = appContext;
        const { analyticsForPagesData } = appContext.analyticsData || {};

        if (loading || isEmpty(analyticsForPagesData) || !showBarMessage) {
            return null;
        }

        return (<div className='bars-message-container' style={{ left: !this.barChartBodyRoot || !this.barChartBodyRoot.current ? 0 : this.barChartBodyRoot.current.scrollLeft }} >
            <div className='bars-message'>
                {barMessage}
            </div>
        </div>);
    }

    setShowBarMessage(analyticsTime, showBarMessage) {
        const { appContext } = this.props;
        const { activeVisitors } = appContext.analyticsData;

        const barMessageText = isEmpty(analyticsTime) ?
            '' :
            `On ${analyticsTime.formattedCreatedDate} 
            at ${analyticsTime.formattedCreatedTime} 
            on ${analyticsTime.shortUrlFormat}
            there were ${analyticsTime.numberOfActiveVisitors}
            visitors or ${analyticsTime.visitedPercentage}% 
            out of ${activeVisitors}`;

        this.setState((prevState) => {
            return {
                ...prevState,
                showBarMessage,
                barMessage: barMessageText
            };
        });
    }

    render() {
        const { appContext } = this.props;
        const { loading } = appContext;

        return (
            <div ref={this.barChartBodyRoot}
                className='analytics-grid-item-root analytics-grid-times-chart-root analytics-component grid-item'>
                <div className='analytics-grid-item-data'>
                    <div className='card-header-root'>
                        <div className='card-header-content'>
                            <span className='card-header-title'>
                                <h6> {'Pages times bar chart'}</h6>
                            </span>
                        </div>
                    </div>

                    <div >
                        {this.displayBarBannerMessage()}
                        <div className='bars-container' >
                            {loading && 'Loading...'}
                            {this.displayChartBars()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withAnalyticsAppContext(AnalyticsTimeBarChart);
